(function () {
  const initialized = new WeakSet();
  function initializeGalleries() {
    document.querySelectorAll('[data-cf-product-gallery]').forEach((gallery) => {
      if (initialized.has(gallery)) return;
      const dialog = gallery.parentElement.querySelector('[data-cf-image-viewer]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      let links = Array.from(gallery.querySelectorAll('.cf-product-image-link'));
      if (!links.length) return;
      initialized.add(gallery);
      const mobile = window.matchMedia('(max-width: 760px)');
      let scrollFrame;
      let controls;
      let mobileCount;
      function currentSlide() {
        const box = gallery.getBoundingClientRect();
        return links.reduce((best, link, i) => Math.abs(link.getBoundingClientRect().left - box.left) < Math.abs(links[best].getBoundingClientRect().left - box.left) ? i : best, 0);
      }
      function updateCount() {
        if (mobileCount) mobileCount.textContent = (currentSlide() + 1) + ' / ' + links.length;
      }
      function scrollToSlide(i, animate = true) {
        const link = links[(i + links.length) % links.length];
        if (!link || !mobile.matches) return;
        const left = gallery.scrollLeft + link.getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollTo({ left, behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      links.forEach((link) => {
        const photo = link.querySelector('img');
        const setBackground = () => link.style.setProperty('--cf-gallery-photo', 'url(' + JSON.stringify(photo.currentSrc || photo.src) + ')');
        setBackground();
        photo.addEventListener('load', setBackground);
      });
      gallery.classList.add('cf-mobile-swipe-gallery');
      if (links.length > 1) {
        controls = document.createElement('div');
        controls.className = 'cf-mobile-gallery-controls';
        const prev = document.createElement('button');
        prev.type = 'button'; prev.textContent = '←'; prev.setAttribute('aria-label', 'Previous product photo');
        const nextPhoto = document.createElement('button');
        nextPhoto.type = 'button'; nextPhoto.textContent = '→'; nextPhoto.setAttribute('aria-label', 'Next product photo');
        mobileCount = document.createElement('span');
        mobileCount.setAttribute('role', 'status'); mobileCount.setAttribute('aria-live', 'polite');
        const hint = document.createElement('span'); hint.textContent = 'Swipe for more photos';
        hint.className = 'cf-mobile-gallery-hint';
        controls.append(prev, mobileCount, nextPhoto, hint);
        gallery.after(controls);
        prev.addEventListener('click', () => scrollToSlide(currentSlide() - 1));
        nextPhoto.addEventListener('click', () => scrollToSlide(currentSlide() + 1));
      }
      gallery.addEventListener('scroll', () => {
        if (scrollFrame) cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateCount);
      }, { passive: true });
      function syncMobile() {
        links.forEach((link) => {
          link.setAttribute('aria-label', (mobile.matches ? 'Enlarge image: ' : 'Show image: ') + link.querySelector('img').alt);
          if (mobile.matches) link.setAttribute('aria-haspopup', 'dialog');
        });
        if (mobile.matches) requestAnimationFrame(() => scrollToSlide(links.indexOf(selectedLink), false));
        updateCount();
      }
      mobile.addEventListener('change', syncMobile);
      let selectedLink = links[0];
      let featured = null;
      if (!gallery.hasAttribute('data-cf-fixed-gallery')) {
        featured = document.createElement('a');
        featured.className = 'cf-product-featured-link';
        featured.setAttribute('aria-haspopup', 'dialog');
        gallery.classList.add('cf-featured-gallery');
        gallery.prepend(featured);
        function selectLink(link) {
          if (!link) return;
          selectedLink = link;
          scrollToSlide(links.indexOf(link));
          featured.href = link.href;
          featured.setAttribute('aria-label', 'Enlarge image: ' + link.querySelector('img').alt);
          const preview = link.querySelector('img').cloneNode(true);
          preview.loading = 'eager';
          featured.replaceChildren(preview);
          const icon = document.createElement('span');
          icon.className = 'cf-image-enlarge';
          icon.textContent = '↗';
          icon.setAttribute('aria-hidden', 'true');
          featured.append(icon);
          links.forEach((item) => {
            item.setAttribute('aria-current', String(item === link));
            item.setAttribute('aria-label', 'Show image: ' + item.querySelector('img').alt);
            if (mobile.matches) item.setAttribute('aria-haspopup', 'dialog');
            else item.removeAttribute('aria-haspopup');
          });
        }
        gallery.cfSelectMedia = (id) => selectLink(links.find((link) => link.dataset.cfMediaId === String(id)));
        selectLink(selectedLink);
        featured.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          opener = featured;
          showImage(links.indexOf(selectedLink));
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          fitImage();
          document.body.style.overflow = 'hidden';
        });
      }
      const image = dialog.querySelector('[data-cf-image-full]');
      const stage = dialog.querySelector('.cf-image-viewer-stage');
      const count = dialog.querySelector('[data-cf-image-count]');
      const zoom = dialog.querySelector('[data-cf-image-zoom]');
      const previous = dialog.querySelector('[data-cf-image-prev]');
      const next = dialog.querySelector('[data-cf-image-next]');
      let index = 0;
      let opener = null;
      let previousOverflow = '';
      let scale = 1;
      let panX = 0;
      let panY = 0;
      let fitWidth = 0;
      let fitHeight = 0;
      let drag = null;
      function paint() {
        const limitX = Math.max(0, (fitWidth * scale - stage.clientWidth) / 2);
        const limitY = Math.max(0, (fitHeight * scale - stage.clientHeight) / 2);
        panX = Math.max(-limitX, Math.min(limitX, panX));
        panY = Math.max(-limitY, Math.min(limitY, panY));
        image.style.width = fitWidth + 'px';
        image.style.height = fitHeight + 'px';
        image.style.transform = 'translate(calc(-50% + ' + panX + 'px), calc(-50% + ' + panY + 'px)) scale(' + scale + ')';
        dialog.classList.toggle('is-zoomed', scale > 1);
        zoom.setAttribute('aria-pressed', String(scale > 1));
        zoom.textContent = scale > 1 ? 'Reset zoom' : 'Zoom in';
      }
      function fitImage() {
        if (!image.naturalWidth || !stage.clientWidth || !stage.clientHeight) return;
        const fit = Math.min(stage.clientWidth / image.naturalWidth, stage.clientHeight / image.naturalHeight, 1);
        fitWidth = image.naturalWidth * fit;
        fitHeight = image.naturalHeight * fit;
        paint();
      }
      function resetZoom() {
        scale = 1;
        panX = panY = 0;
        drag = null;
        dialog.classList.remove('is-dragging');
        paint();
      }
      function setZoom(targetScale, clientX, clientY) {
        const nextScale = Math.max(1, Math.min(5, targetScale));
        const rect = stage.getBoundingClientRect();
        const x = clientX == null ? 0 : clientX - rect.left - stage.clientWidth / 2;
        const y = clientY == null ? 0 : clientY - rect.top - stage.clientHeight / 2;
        panX = x - (x - panX) * nextScale / scale;
        panY = y - (y - panY) * nextScale / scale;
        scale = nextScale;
        paint();
      }
      image.addEventListener('load', fitImage);
      if (typeof ResizeObserver === 'function') new ResizeObserver(fitImage).observe(stage);
      stage.addEventListener('wheel', (event) => {
        if (!dialog.open) return;
        event.preventDefault();
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? stage.clientHeight : 1);
        setZoom(scale * Math.exp(-Math.max(-200, Math.min(200, delta)) * .002), event.clientX, event.clientY);
      }, { passive: false });
      stage.addEventListener('pointerdown', (event) => {
        if (scale <= 1 || event.button !== 0) return;
        event.preventDefault();
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, panX: panX, panY: panY };
        stage.setPointerCapture(event.pointerId);
        dialog.classList.add('is-dragging');
      });
      stage.addEventListener('pointermove', (event) => {
        if (!drag || drag.id !== event.pointerId) return;
        panX = drag.panX + event.clientX - drag.x;
        panY = drag.panY + event.clientY - drag.y;
        paint();
      });
      function endDrag(event) {
        if (!drag || drag.id !== event.pointerId) return;
        drag = null;
        dialog.classList.remove('is-dragging');
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('lostpointercapture', endDrag);
      function showImage(targetIndex) {
        index = (targetIndex + links.length) % links.length;
        if (featured) gallery.cfSelectMedia(links[index].dataset.cfMediaId);
        resetZoom();
        image.src = links[index].href;
        image.alt = links[index].querySelector('img').alt;
        count.textContent = (index + 1) + ' / ' + links.length;
        previous.disabled = next.disabled = links.length < 2;
      }
      links.forEach((link, linkIndex) => {
        link.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (featured && !mobile.matches) { gallery.cfSelectMedia(link.dataset.cfMediaId); featured.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); return; }
          opener = link;
          links = Array.from(gallery.querySelectorAll('.cf-product-image-link'));
          showImage(links.indexOf(link));
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          fitImage();
          document.body.style.overflow = 'hidden';
        });
      });
      syncMobile();
      dialog.querySelector('[data-cf-image-close]').addEventListener('click', () => dialog.close());
      previous.addEventListener('click', () => showImage(index - 1));
      next.addEventListener('click', () => showImage(index + 1));
      zoom.addEventListener('click', () => scale > 1 ? resetZoom() : setZoom(2));
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        resetZoom();
        if (opener && opener.isConnected) opener.focus();
      });
    });
  }
  initializeGalleries();
  document.addEventListener('shopify:section:load', initializeGalleries);
})();

